export default __webpack_public_path__ + "static/media/Scholar's Boots of the Eternal Eclipse.79173d40.jpg";